// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleYouTubePreview__container-d7a26c {
  position: relative;
  width: 100%;
}

.ArticleYouTubePreview__youtube-bf0f6d {
  border-radius: 16px;
}

.ArticleYouTubePreview__title-dc1c52 {
  position: absolute;
  top: 0px;
  inset-inline-start: 0px;
  width: 100%;
  padding: 21px 16px;
  font: var(--font-body-1);
  letter-spacing: var(--font-body-1);
  font-weight: 400;
  color: var(--addition-50);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0) 100%);
  box-sizing: border-box;
  border-radius: 16px 16px 0px 0px;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/components/ArticleYouTubePreview/ArticleYouTubePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,kCAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kFAAA;EACA,sBAAA;EACA,gCAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n}\n\n.youtube {\n  border-radius: 16px;\n}\n\n.title {\n  position: absolute;\n  top: 0px;\n  inset-inline-start: 0px;\n  width: 100%;\n  padding: 21px 16px;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-body-1);\n  font-weight: 400;\n  color: var(--addition-50);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0) 100%);\n  box-sizing: border-box;\n  border-radius: 16px 16px 0px 0px;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleYouTubePreview__container-d7a26c`,
	"youtube": `ArticleYouTubePreview__youtube-bf0f6d`,
	"title": `ArticleYouTubePreview__title-dc1c52`
};
module.exports = ___CSS_LOADER_EXPORT___;
